import type { HomeSyncProgress } from '../email/useHomeRefresh';
import { GmailMark } from '../email/MailSurface';
import { CalendarMark } from './IntegrationBar';
import { Icon } from '../ui/Icon';
import styles from './Integrations.module.css';

export function HomeSyncStatus({ progress }: { progress: HomeSyncProgress | null }) {
  if (!progress) return null;
  return <div className={styles.syncProgress} aria-label="Auto Progress sync">
    {(['gmail', 'google_calendar'] as const).map(provider => {
      const state = progress[provider];
      const name = provider === 'gmail' ? 'Gmail' : 'Calendar';
      const label = state.status === 'syncing' ? `Syncing ${name}…`
        : state.status === 'synced' ? `${name} synced`
        : state.status === 'disconnected' ? `${name} not connected`
        : state.error ?? `${name} couldn’t sync.`;
      return <div key={provider} className={styles.syncRow} role={state.status === 'error' ? 'alert' : 'status'} aria-label={label}>
        {provider === 'gmail' ? <GmailMark /> : <CalendarMark />}
        <span>{label}</span>
        {state.status === 'syncing' && <span className={styles.refreshSpinner} aria-hidden="true" />}
        {state.status === 'synced' && <Icon name="check" size={15} />}
      </div>;
    })}
  </div>;
}
